module.exports = __webpack_public_path__ + "static/media/nike-oranje-fatalis-3.5d48a840.jpg";